<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="产品名称">
            <a-input v-decorator="['name']" allow-clear placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="有效性">
            <a-select v-decorator="['effective']" allow-clear placeholder="全部">
              <a-select-option value="1">有效</a-select-option>
              <a-select-option value="0">无效</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'SearchAgentsEsimProduct',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agents_esim_product_search' })
    }
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) this.$emit('submit', values)
      })
    },
    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
